/**
 * 工作流工具栏弹层：锚定按钮下方，并限制在视口内
 */

export function getAnchorRect(el) {
  if (!el || typeof el.getBoundingClientRect !== 'function') return null
  const r = el.getBoundingClientRect()
  return {
    top: r.top,
    left: r.left,
    bottom: r.bottom,
    right: r.right,
    width: r.width,
    height: r.height
  }
}

/**
 * @param {object|null} anchor getAnchorRect 返回值
 * @param {{ panelWidth: number, panelMaxHeight?: number, gap?: number, align?: 'left'|'right' }} opts
 */
export function computeAnchoredPanelStyle(anchor, opts) {
  const panelWidth = opts.panelWidth || 420
  const gap = opts.gap != null ? opts.gap : 10
  const align = opts.align === 'right' ? 'right' : 'left'
  const margin = 12
  const vw = window.innerWidth || 1200
  const vh = window.innerHeight || 800
  const maxHeight = opts.panelMaxHeight != null ? opts.panelMaxHeight : Math.min(520, vh - margin * 2)

  if (!anchor) {
    return {
      top: `${Math.round(vh * 0.3)}px`,
      left: `${Math.round((vw - panelWidth) / 2)}px`,
      width: `${panelWidth}px`,
      maxHeight: `${maxHeight}px`
    }
  }

  let left = align === 'right' ? anchor.right - panelWidth : anchor.left
  left = Math.max(margin, Math.min(left, vw - panelWidth - margin))

  let top = anchor.bottom + gap
  let maxH = maxHeight

  if (top + maxH > vh - margin) {
    const spaceBelow = vh - margin - top
    const spaceAbove = anchor.top - gap - margin
    if (spaceAbove > spaceBelow && spaceAbove > 160) {
      maxH = Math.min(maxHeight, spaceAbove)
      top = anchor.top - gap - maxH
    } else {
      maxH = Math.min(maxHeight, Math.max(160, spaceBelow))
    }
  }

  return {
    top: `${Math.round(top)}px`,
    left: `${Math.round(left)}px`,
    width: `${panelWidth}px`,
    maxHeight: `${Math.round(maxH)}px`
  }
}
